// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700;800&display=swap);"]);
// Module
exports.push([module.id, "body {\n  font-family: Noto Sans JP;\n}\n\n.cfwFQ6F5_HOlFuVgr7NDU {\n  color: #509d96;\n}\n\n.zA3ccBLDS7teB-WWYahz_ {\n  color: var(--green_a50);\n}\n\n.x9RbrA7zJn_f6dPQYAnWD {\n  color: var(--red);\n}\n\n._2TvZfYkx_zAkIfMAJko95q {\n  color: var(--black);\n}\n\n.bzc2wGY4YISgquddy0v2U {\n  color: var(--black_a90);\n}\n\n._2O7u4HoUsMLHpD9dmfy51A {\n  color: #9c9f9f;\n}\n\n.y9LJsOuYM5FnRmvmd_sHp {\n  background-color: var(--gray_a50);\n}\n\n._2UqCIyHGormjSNCcJoHr4i {\n  font-weight: 700;\n}\n\n._3EXS-yEw7H19Kgc57BzyMj {\n  font-weight: 800;\n}\n\n._eCdFxJFGEsHFMNcxmeb8 {\n  padding: 20px;\n}\n\n._2izFKQDcVXjk44nObi0CuN {\n  font-size: 16px;\n}\n\n._2DpfPpk3XLBDQ4SP5GUQEC {\n  font-size: 20px;\n}", ""]);
// Exports
exports.locals = {
	"green": "#509d96",
	"green_a50": "#509d9680",
	"green_f90": "#edf5f4",
	"green_b20": "#4b8a85",
	"red": "#de6162",
	"red_f90": "#fcefef",
	"red_b20": "#bd5a5b",
	"black": "#383e3f",
	"black_a90": "#383e3fe5",
	"gray": "#9c9f9f",
	"gray_a50": "#9c9f9f80",
	"gray_a20": "#9c9f9f33",
	"gray_a10": "#9c9f9f1a",
	"gray_f90": "#f5f5f5",
	"gray_f50": "#cecfcf",
	"gray_b20": "#888b8c",
	"gray_b90": "#424849",
	"white": "#ffffff",
	"white_a90": "#ffffffe5",
	"primary": "cfwFQ6F5_HOlFuVgr7NDU",
	"switch_on": "zA3ccBLDS7teB-WWYahz_",
	"alert": "x9RbrA7zJn_f6dPQYAnWD",
	"surface_bk": "_2TvZfYkx_zAkIfMAJko95q",
	"overlay_bg": "bzc2wGY4YISgquddy0v2U",
	"grayText": "_2O7u4HoUsMLHpD9dmfy51A",
	"selected_row": "y9LJsOuYM5FnRmvmd_sHp",
	"bold": "_2UqCIyHGormjSNCcJoHr4i",
	"bolder": "_3EXS-yEw7H19Kgc57BzyMj",
	"padded": "_eCdFxJFGEsHFMNcxmeb8",
	"midsize-font": "_2izFKQDcVXjk44nObi0CuN",
	"largeFont": "_2DpfPpk3XLBDQ4SP5GUQEC"
};
module.exports = exports;
